import { Capacitor } from "@capacitor/core";
import { NativeSettings, AndroidSettings, IOSSettings } from "capacitor-native-settings";

/**
 * Opens the app’s settings page so the user can enable location (and other) permissions.
 * Same navigation pattern as notification settings — app details on Android, app settings on iOS.
 */
export async function openLocationSettings(): Promise<void> {
  try {
    await NativeSettings.open({
      optionAndroid: AndroidSettings.ApplicationDetails,
      optionIOS: IOSSettings.App,
    });
  } catch (error) {
    if (Capacitor.isNativePlatform()) {
      console.error("Failed to open location settings:", error);
    }
  }
}
